<div class="label-header">
    <label class="label-headercolor">Target Scenario </label>
</div>


<ag-grid-angular style="width: 100%;" class="ag-theme-alpine" id="ProcessCost" [rowData]="tgtProcessCostRowData"
    [columnDefs]="tgtProcessCostColumnDefs" [defaultColDef]="defaultColDef"
    [rowClassRules]="rowClassRules" [domLayout]="domLayout" [rowHeight]="rowHeight" [headerHeight]="headerHeight"
    (gridReady)="ontgtProcessCostGridReady($event)" (gridSizeChanged)="ontgtProcessCostGridSizeChanged($event)">
</ag-grid-angular>